import React from "react";
import { Container, MainContainer, SideContainer, FormLogin } from "./styled";
import { Link } from "react-router-dom";

const LoginContainer = (props) => {
  const {
    email,
    setEmail,
    password,
    setPassword,
    handleLogin,
    emailError,
    passwordError,
    from,
  } = props;

  return (
    <Container>
      <SideContainer>
        <Link to="/">
          <img src="/assets/Logo.png" alt="Logo Deportactico" />
        </Link>
        <h1>Iniciar sesion</h1>
        <p>
          Necesitas una cuenta? {/* <Link to="/app/register"> */}
          <Link to={{ pathname: "/app/register", state: from }}>
            <strong>Crea una cuenta</strong>
          </Link>
        </p>
        <FormLogin
          onSubmit={(e) => {
            e.preventDefault();
            handleLogin();
          }}
        >
          <div>
            <input
              className="input"
              name="email"
              type="email"
              placeholder="Usuario"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <p>{emailError}</p>
          </div>
          <div>
            <input
              className="input"
              name="email"
              type="password"
              placeholder="Contraseña"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <p>{passwordError}</p>
          </div>
          <button id="loginSubmit">INICIAR SESION</button>
        </FormLogin>
      </SideContainer>
      <MainContainer>
        <img src="/assets/login-background-img.jpg" alt="3d basketball court" />
      </MainContainer>
    </Container>
  );
};
export default LoginContainer;
